import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  baseUrl = environment.quote_url;
  userType: BehaviorSubject<any> = new BehaviorSubject(this.getUserType());

  constructor(private http: HttpClient) { }

  getUserType() {
    return localStorage.getItem('role');
  }

  SignUpAuth(data: any): Observable<any> {
    const apiURL = `${environment.quote_auth_url}auth/signup`;
    return this.http.post<any>(apiURL, data);
  }

  SignInAuth(data: any): Observable<any> {
    const apiURL = `${environment.quote_auth_url}auth/login`;
    return this.http.post<any>(apiURL, data);
  }

  HandleLogout(): Observable<any> {
    const apiURL = `${environment.quote_auth_url}auth/logout`;
    return this.http.get<any>(apiURL);
  }

  GetProfileData(): Observable<any> {
    const apiURL = `${environment.quote_auth_url}auth/profile`;
    return this.http.get<any>(apiURL);
  }

}
